<template>
    <div>
        <pool 
            v-for="(pool, index) in pools" :key="index"
            :pool="pool">
        </pool>

    </div>

</template>

<script>
import Pool from './Pool'

export default {
    name: 'AllPools',
    components: {
        Pool
    },
    props: {
        pools: {
            type: Array
        },
        pool_type: {
            type: String
        }
    },
}
</script>

<style>

</style>